import { useAppSelector } from "../../app/hooks";
import { useTranslation, Trans } from "react-i18next";

import styles from "./Waiting.module.css";

interface Props {
  activeNumberOfPlayers: number;
  totalNumberOfPlayers: number;
}

export default function Waiting({
  activeNumberOfPlayers,
  totalNumberOfPlayers,
}: Props) {
  const roomId = useAppSelector((state) => state.user.roomId);
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <h2 className={styles.heading}>
          {t("Waiting.title")}
          <span className={styles.dots}>...</span>
        </h2>
        <p className={styles.message}>
          <Trans
            i18nKey="Waiting.message"
            count={activeNumberOfPlayers}
            values={{
              roomId,
              totalNumberOfPlayers,
            }}
            components={{ strong: <strong /> }}
          />
        </p>
      </div>
    </div>
  );
}
